<template>
  <div class="login">
    <div class="input_login">
      <div class="l_left">
        <!-- <img class="l_logon_img" src="@/assets/image/logo.png" alt=""> -->
        <div style="margin-top: 30px;margin-left:6px;font-size:28px;text-align: center;">
          实景GIS三维空间漫游
        </div>
        <h1 class="title">登录</h1>
        <el-form label-position="left" label-width="55px" class="loginForm">
          <el-form-item>
            <el-input v-model="username" class="input" type="text" prefix-icon="User"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="password" class="input" type="password" prefix-icon="Unlock">
            </el-input>
          </el-form-item>
          <el-form-item style="display: flex">
            <el-input type="text" ref="inputCode" v-model="inputCode" placeholder="请输入验证码" clearable
              style="width: 123px; margin-left: -40px"></el-input>
            <span @click="createCode" id="spancode">
              <SidentifyVue :identifyCode="code"></SidentifyVue>
            </span>
          </el-form-item>
          <el-form-item>
            <div class="btnBox">
              <el-button class="btn" color="#3160eb" round @click="onlogin">登录</el-button>
              <!-- <el-button class="btn" color="#3160eb" round @click="torigister">注册</el-button> -->
            </div>
          </el-form-item>
          <!-- <el-form-item> -->
          <p class="l_tips">登录即视为同意</p>
          <a class="l_tips_a" href="">用户协议</a>
          <a class="l_tips_a1" href="">版权声明</a>
          <!-- </el-form-item> -->

        </el-form>
      </div>
      <div class="l_right">
        <img src="@/assets/image/l_img1.jpg" alt="">
      </div>
    </div>
    <!-- <p class="l_footer">佛山配致科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;版权所有&nbsp;&nbsp;&nbsp;&nbsp;粤ICP备2021121089号</p> -->
  </div>

</template>

<script>
import { inject } from 'vue';
import { login, getuserinfo } from '@/api/api';
import { ElMessage } from 'element-plus';
import { User, Unlock } from '@element-plus/icons-vue';
import md5 from 'js-md5'
import SidentifyVue from "@/components/Sidentify.vue";
export default {
  components: {
    SidentifyVue, User, Unlock,
  },
  data() {
    return {
      code: "",
      inputCode: "",
      username: null,
      password: null,
      userInfo: inject('global').userInfo,
    };
  },
  methods: {
    onlogin() {
      if (this.username == null && this.password == null) {
        ElMessage({
          message: "请输入账号密码",
          type: "warning",
        });
      } else {
        if (this.inputCode == "") {
          ElMessage({
            message: "请输入验证码",
            type: "warning",
          });
          return;
        } else if (this.inputCode != this.code) {
          ElMessage({
            message: "验证码错误",
            type: "warning",
          });
          this.inputCode = "";
          this.createCode();
          return;
        }
        var param = {
          username: this.username,
          // password: this.password,
          password: md5(this.password),
        };
        login(param).then((res) => {
          if (res.data.token != undefined) {
            ElMessage({
              message: '登录成功',
              type: 'success',
            });
            this.getuserinfoData();
            localStorage.removeItem('token');
            localStorage.setItem('token', res.data.token);
            this.$cookies.set('token', res.data.token);
            this.$cookies.set('user-token', res.data.token, null, '');
            this.$store.commit('saveUserInfo', res.data.userinfo)
            this.$router.push('/project')
          } else {
            ElMessage({
              message: res.data,
              type: 'warning',
            })
          }
        })
      }
    },
    torigister() {
      this.$router.push('/register')
    },
    // 回车键登录
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e != undefined) {
        if (e.keyCode == 13 || e.keyCode == 108) {
          this.onlogin();
        }
      }
    },
    /** 验证码登录 */
    createCode() {
      let text = "";
      let possible = "abcdefghijklmnopqrstuvwxyz0123456789";
      // 设置验证码长度，
      for (let i = 0; i < 4; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      this.code = text;
    },
    /** 获取用户信息 */
    getuserinfoData() {
      getuserinfo().then((res) => {
        console.log("用户信息", res);
        this.userInfo = res.data;
        localStorage.setItem('userId', res.data.id);
      })
    }
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown);
    this.createCode();
  }
};
</script>
<style lang="scss">
@import "@/assets/css/icon.css";
@import "@/assets/css/index/login.scss";
</style>
